module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-island-kitchen-80ca7990.jpg";